import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import { Button } from '../../components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';
import PaymentLogs from '../../components/admin/PaymentLogs';

const FinanceLogsPage = () => {
  const navigate = useNavigate();

  return (
    <Layout>
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin/finances')}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Finances
        </Button>
        
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <FileText className="w-8 h-8" />
          Payment Transaction Logs
        </h1>
        <p className="text-gray-600 mt-2">View all payment transactions and user details</p>
      </div>

      <PaymentLogs />
    </div>
    </Layout>
  );
};

export default FinanceLogsPage;
